import React, { useState, useEffect } from "react";
import axios from "axios";
import { Snackbar, TextField, Button, Typography, IconButton, Collapse } from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import "../shared/modern-ui.css";

const UpdateCompanyInfo = () => {
    const [companyInfo, setCompanyInfo] = useState({
        company_name: "",
        email: "",
        phone: "",
        website: "",
        company_number: "",
        support_document: null
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [openHelp, setOpenHelp] = useState(false); // Yardım açma

    // Şirket bilgilerini çekme
    useEffect(() => {
        const fetchCompanyInfo = async () => {
            try {
                const res = await axios.get("https://kariyer.biyomed.net/api/companies/getOne", {
                    withCredentials: true,
                });
                if (res.data.company) {
                    setCompanyInfo(res.data.company);
                }
            } catch (error) {
                console.error("Şirket bilgileri alınırken hata oluştu:", error);
                setSnackbarMessage("Şirket bilgileri alınırken hata oluştu!");
                setOpenSnackbar(true);
            }
        };

        fetchCompanyInfo();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCompanyInfo({
            ...companyInfo,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== "application/pdf") {
            setSnackbarMessage("Sadece PDF dosyaları yüklenebilir!");
            setOpenSnackbar(true);
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            setSnackbarMessage("Dosya boyutu 5MB'ı geçemez!");
            setOpenSnackbar(true);
            return;
        }

        setSelectedFile(file);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!companyInfo.company_name || !companyInfo.email || !companyInfo.phone || !companyInfo.website) {
            setSnackbarMessage("Tüm alanlar zorunludur!");
            setOpenSnackbar(true);
            return;
        }

        const formData = new FormData();
        formData.append("company_name", companyInfo.company_name);
        formData.append("email", companyInfo.email);
        formData.append("phone", companyInfo.phone);
        formData.append("website", companyInfo.website);
        formData.append("company_number", companyInfo.company_number);
        formData.append("type", companyInfo.type);

        if (selectedFile) {
            formData.append("support_document", selectedFile);
        }

        try {
            await axios.put("https://kariyer.biyomed.net/api/register/updateCompanyInfo", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            });

            setSnackbarMessage("Şirket bilgileri başarıyla güncellendi!");
            setOpenSnackbar(true);
        } catch (error) {
            setSnackbarMessage("Bir hata oluştu!");
            setOpenSnackbar(true);
            console.error(error);
        }
    };

    return (
        <div className="bm-page">
            <div className="bm-container bm-container--narrow">
                <div className="bm-page-head">
                    <h1 className="bm-page-title">Kayıt Bilgileri</h1>
                    <p className="bm-page-sub">
                        Firma kaydınızda yer alan bilgiler. Kilitli alanlar için bizimle iletişime geçebilirsiniz.
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="bm-card">
                        <div className="bm-card-head">
                            <span className="bm-card-badge"><i className="fa fa-building-o" /></span>
                            <h3>Firma Bilgileri</h3>
                        </div>

                        <div className="bm-card-body">
                            <div className="bm-form-grid">
                                <div className="bm-field bm-field--wide">
                                    <TextField fullWidth size="small" label="Şirket Adı" name="company_name" value={companyInfo.company_name} onChange={handleInputChange} disabled />
                                </div>
                                <div className="bm-field bm-field--wide">
                                    <TextField fullWidth size="small" label="Email" name="email" type="email" value={companyInfo.email} onChange={handleInputChange} disabled />
                                </div>
                                <div className="bm-field">
                                    <TextField fullWidth size="small" label="Telefon" name="phone" value={companyInfo.phone} onChange={handleInputChange} required />
                                </div>
                                <div className="bm-field">
                                    <TextField fullWidth size="small" label="Website" name="website" value={companyInfo.website} onChange={handleInputChange} required />
                                </div>
                                <div className="bm-field bm-field--wide">
                                    <TextField fullWidth size="small" label="Vergi No / ÜTS Firma No" name="company_number" value={companyInfo.company_number} disabled onChange={handleInputChange} />
                                </div>
                            </div>

                            {/* Destek Belgesi Yükleme Alanı */}
                            <div className="bm-section" style={{ marginTop: 28 }}>
                                <h4 className="bm-section-title">Destekleyici Belge</h4>
                                <div className={`bm-upload${companyInfo.support_document ? " bm-upload--filled" : ""}`}>
                                    <span className="bm-upload-icon">
                                        <i className={`fa ${companyInfo.support_document ? "fa-check" : "fa-file-pdf-o"}`} />
                                    </span>
                                    <span className="bm-upload-text">
                                        <span className="bm-upload-title">
                                            {companyInfo.support_document ? "Yüklü dosya mevcut" : "Dosya mevcut değil"}
                                        </span>
                                        <span className="bm-upload-sub">
                                            {selectedFile ? `Seçilen dosya: ${selectedFile.name}` : "PDF · en fazla 5MB · değişiklik için destek ekibiyle görüşün"}
                                        </span>
                                    </span>
                                    <input disabled type="file" accept="application/pdf" onChange={handleFileChange} />
                                </div>
                            </div>
                        </div>

                        <div className="bm-form-footer bm-form-footer--end">
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{ textTransform: "none", borderRadius: "10px", px: 3, py: 1.1, fontWeight: 600 }}
                            >
                                Güncelle
                            </Button>
                        </div>
                    </div>
                </form>

                {/* Yardım Mesajı */}
                <div style={{ textAlign: "center", marginTop: 28 }}>
                    <Typography component="span" sx={{ color: "#334155", fontSize: "15px", fontWeight: 600 }}>
                        Neden her şeyi güncelleyemiyorum?
                    </Typography>
                    <IconButton onClick={() => setOpenHelp(!openHelp)} sx={{ ml: 0.5 }} size="small">
                        <HelpIcon color="disabled" fontSize="small" />
                    </IconButton>

                    {/* Yardım Açıklaması */}
                    <Collapse in={openHelp}>
                        <div className="bm-note" style={{ marginTop: 12, textAlign: "left" }}>
                            <i className="fa fa-info-circle" style={{ marginTop: 2 }} />
                            <span>
                                Bu alanlar genellikle admin veya sistem yöneticisi tarafından düzenlenebilir.
                                Bizimle iletişime geçerek bu alanlarda değişiklik yapılmasını talep edebilirsiniz.
                            </span>
                        </div>
                    </Collapse>
                </div>

                {/* Snackbar for error/success messages */}
                <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={() => setOpenSnackbar(false)} message={snackbarMessage} />
            </div>
        </div>
    );
};

export default UpdateCompanyInfo;
